import React from 'react';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../scss/controls/_addressLocation.scss';

export enum AddressLocationIndicatorStyle {
    Blue = 'blue',
    Black = 'black',
    Gray = 'gray',
    Red = 'red',
}

export enum AddressLocationLine1Style {
    Regular = 'regular',
    Bold = 'bold',
}

export enum AddressLocationControlPadding {
    None = 'noPadding',
    Regular = 'regularPadding',
}

export enum AddressLocationFontSize {
    Normal = 'regularFontSize',
    Smaller = 'smallerFontSize',
}

export const AddressLocation: React.FC<{
    addressLine1: string;
    addressLine2?: string;
    propertyNumber?: number;
    width?: string;
    height?: string;
    indicatorStyle?: AddressLocationIndicatorStyle;
    line1Style?: AddressLocationLine1Style;
    controlPadding?: AddressLocationControlPadding;
    showIndicator?: boolean;
    fontSize?: AddressLocationFontSize;
}> = ({
    addressLine1,
    addressLine2,
    propertyNumber,
    width = 'auto',
    height = 'auto',
    indicatorStyle = AddressLocationIndicatorStyle.Blue,
    line1Style = AddressLocationLine1Style.Regular,
    controlPadding = AddressLocationControlPadding.Regular,
    showIndicator = true,
    fontSize = AddressLocationFontSize.Normal,
}) => {
    const setStyle = {
        width: `${width}`,
        height: `${height}`,
    };

    return (
        <>
            <div
                className={`addressLocation-container ${controlPadding}`}
                style={setStyle}
            >
                {showIndicator && (
                    <div className={`addressLocation-locator ${indicatorStyle} ${fontSize}`}>
                        <FontAwesomeIcon
                            icon={faLocationDot}
                            className='icon'
                        />
                    </div>
                )}

                <div className='addressLocation-address'>
                    <div className={`addressLocation-lineOne ${line1Style} ${fontSize}`}>
                        {propertyNumber && `(${propertyNumber}) `}
                        {addressLine1}
                    </div>
                    <div className={`addressLocation-lineTwo ${fontSize}`}>{addressLine2}</div>
                </div>
            </div>
        </>
    );
};
